export const MERKLE_PROOF_ENDPOINT = 'https://lf8d031acj.execute-api.ap-east-1.amazonaws.com/api/v1/merkle_tree/leaf_exists';
export const DEFAULT_MERKLE_PROOF = '0x0000000000000000000000000000000000000000000000000000000000000000';
